"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleFilterDropdownRender = exports.filterIconRender = exports.filterDropdownRender = exports.expandIconRender = exports.Info = exports.Help = void 0;
var _RightLine = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/direction/RightLine.svg"));
var _FilterFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/FilterFill.svg"));
var _SelectMenuItemSelectedIcon = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/component/SelectMenuItemSelectedIcon.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../_util/utils");
var _useConfig = require("../hooks/useConfig");
var _icon = _interopRequireDefault(require("../icon"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const filterDropdownRender = props => {
  const {
    clearFilters,
    selectedKeys,
    setSelectedKeys,
    filters,
    confirm,
    filterMultiple = true,
    selectAllText
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = (0, _useConfig.useConfig)();
  const renderItem = (item, index) => {
    const itemAttrs = (0, _utils.pickDomAttrs)(item);
    const isSelected = selectedKeys.some(key => key === item.value);
    return /*#__PURE__*/(0, _react.createElement)("div", {
      ...itemAttrs.data,
      className: (0, _classnames.default)('item', {
        ['item-selected']: isSelected
      }),
      key: index,
      onClick: () => {
        if (filterMultiple) {
          if (isSelected) {
            const newkeys = selectedKeys.filter(key => key !== item.value);
            setSelectedKeys(newkeys);
          } else {
            const newkeys = [...selectedKeys, item.value];
            setSelectedKeys(newkeys);
          }
          confirm({
            closeDropdown: false
          });
        } else {
          if (isSelected) {
            setSelectedKeys([]);
          } else {
            setSelectedKeys([item.value]);
          }
          confirm({
            closeDropdown: true
          });
        }
      }
    }, item.text, isSelected && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      className: "checkIcon",
      type: "component/SelectMenuItemSelectedIcon",
      fontSize: 16
    }));
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "filter-dropdown-wrap",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)('item', {
        ['item-selected']: !(selectedKeys !== null && selectedKeys !== void 0 && selectedKeys.length)
      }),
      onClick: () => {
        clearFilters === null || clearFilters === void 0 || clearFilters();
        if (filterMultiple) {
          confirm({
            closeDropdown: false
          });
        } else {
          confirm({
            closeDropdown: true
          });
        }
      },
      children: [selectAllText || TableLocale.filter_selectAllText, !(selectedKeys !== null && selectedKeys !== void 0 && selectedKeys.length) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        className: "checkIcon",
        type: "component/SelectMenuItemSelectedIcon",
        fontSize: 16
      })]
    }), filters === null || filters === void 0 ? void 0 : filters.map((item, index) => {
      if (item.children) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "group",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "group-title",
            children: item.text
          }), item.children.map(renderItem)]
        }, index);
      } else {
        return renderItem(item, index);
      }
    })]
  });
};
exports.filterDropdownRender = filterDropdownRender;
const FilterDropdownRender = filterDropdownRender;
const singleFilterDropdownRender = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(FilterDropdownRender, {
    ...props,
    filterMultiple: false
  });
};
exports.singleFilterDropdownRender = singleFilterDropdownRender;
const filterIconRender = filtered => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
    type: "general/FilterFill",
    fontSize: 14,
    className: (0, _classnames.default)('filterIcon', {
      ['filterIcon-active']: !!filtered
    })
  });
};
exports.filterIconRender = filterIconRender;
const Help = props => {
  const {
    title,
    tips,
    iconSize = 16,
    ...tooltipProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default.Help, {
    title: tips,
    iconType: "filled",
    iconSize: iconSize,
    iconClassName: "helpIcon",
    ...tooltipProps,
    children: title
  });
};
exports.Help = Help;
const Info = props => {
  const {
    title,
    tips,
    iconSize = 16,
    ...tooltipProps
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default.Info, {
    title: tips,
    iconType: "filled",
    iconSize: iconSize,
    iconClassName: "infoIcon",
    ...tooltipProps,
    children: title
  });
};
exports.Info = Info;
const expandIconRender = props => {
  const {
    expandable,
    expanded,
    onExpand,
    record
  } = props;
  if (expandable) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
      type: "direction/RightLine",
      fontSize: 16,
      className: (0, _classnames.default)('expandIcon', {
        ['expandIcon-expanded']: expanded
      }),
      onClick: e => {
        onExpand(record, e);
      }
    });
  }
  return null;
};
exports.expandIconRender = expandIconRender;